import {
  FETCH_PERIODOS_REQUEST,
  FETCH_PERIODOS_SUCCESS,
  FETCH_PERIODOS_FAILURE,
} from "../actions/facturacion/types";

const initialState = { items: [], loading: false, error: null };

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PERIODOS_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_PERIODOS_SUCCESS:
      return { ...state, loading: false, items: Array.isArray(action.payload) ? action.payload : [], error: null };
    case FETCH_PERIODOS_FAILURE:
      return { ...state, loading: false, error: action.payload?.error ?? "Error desconocido" };
    default:
      return state;
  }
};

export default reducer;
